<app-dave-list-card
    [Headline]="cls.getMultiple$('Supplier') | async"
    EmptyText="Keine Zuordnungen vorhanden"
    [Data]="MaterialToSupplierTableData$ | async"
    [DisplayedCollums]="['SupplierName', 'Date', 'Cost', 'ArticleNumber','ListPrice', 'SellPrice', 'Icon']"
    [TableHeaderCollumsMap]="{
        SupplierName: supplierLabel$ | async,
        Date: 'Aktualisiert am',
        Cost: 'EK-Preis',
        ArticleNumber: 'Artikelnummer',
        ListPrice: 'Listenpreis',
        SellPrice: 'Verkaufspreis',
    }"
    [HasSuffixButton]="(!!materialEKForm || showSupplierButton || showAcceptPriceButton)"
    [CustomCellTemplates]="{
        Icon: iconcollum
    }"
    [Clickable]="true"
    (EntryClicked$)="onAddSupplier($event.entry)"
    style="max-height: 50vh"
    [IsLoading]="MaterialToSupplierTableDataLoading$ | async"
>
    <button app-round-button headerButton onlyExpanded (click)="onAddSupplier(null)">
        <fa-icon [icon]="'plus'"></fa-icon>
    </button>
</app-dave-list-card>
<ng-template #iconcollum let-data="data">
    <fa-icon matTooltip="Aktuell werden die Stammdaten von diesem {{supplierLabel$ | async}} verwendet." icon="gear" *ngIf="data.UsedInformation"></fa-icon>
</ng-template>
